import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Icons from Ant Design
import PrincipleCreationForm from "../../Forms/PrincipleCreationForm/PrincipleCreationForm"
const PrincipleTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
  userData,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedPrinciple, setSelectedPrinciple] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window principle
  useEffect(() => {
    const handleReprinciple = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("reprinciple", handleReprinciple);
    return () => {
      window.removeEventListener("reprinciple", handleReprinciple);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const principleToEdit = data.find((principle) => principle._id === id);
    if (principleToEdit) {
      setSelectedPrinciple(principleToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedPrinciple(null);
  };

  const isAdmin = userData?.roles?.includes("admin");
  const renderActionButton = (id) => {
    if (!isAdmin) return null;
    return (<>
      {isMobileView ? (
        // Use icons on mobile view
        <>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => handleOpenEditModal(id)}
              principle="small"
              shape="circle"
              style={{ marginRight: 8 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(id)}
              principle="small"
              shape="circle"
              danger
            />
          </Tooltip>
        </>
      ) : (
        // Use buttons on desktop view
        <>
          <Button
            onClick={() => handleOpenEditModal(id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(id)} danger>
            Delete
          </Button>
        </>
      )}
    </>
  );
};

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 400,
    },
  ];

  return (
    <>
      <div style={{width: "50vw"}}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={(pagination, filteredInfo, sorter) =>
                handleTableOnChange(pagination, filteredInfo, sorter)
              }
            />
          )}
        </Spin>
        <Modal
          title="Edit Principle"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <PrincipleCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            data={selectedPrinciple}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

PrincipleTable.propTypes = {
};

export default PrincipleTable;
